module.exports = __webpack_public_path__ + "assets/images/slope-working-2/mobile.svg?v=f833c64a";